import * as z from "zod/v4";

import { StationStep } from "./create-work-order-station";

export const updateWorkOrderStation = {
  name: "updateWorkOrderStation" as const,
  input: z.object({
    stationId: z.string(),
    name: z.string(),
    locationId: z.string().nullable(),
    steps: z.array(StationStep),
  }),
  output: z.object({}),
};
